module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-800-007e92212dd4fb8c92c44b14e497de12.jpg";